var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.13 0H6.32C2.82956 0 0 2.82956 0 6.32V15.13C0 18.6204 2.82956 21.45 6.32 21.45H15.13C18.6204 21.45 21.45 18.6204 21.45 15.13V6.32C21.45 2.82956 18.6204 0 15.13 0Z",
    fill: "url(#paint0_linear_1_280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17933 11.0091H9.92934V11.3291C9.92934 11.4591 10.0393 11.5691 10.1693 11.5691H11.2893C11.4193 11.5691 11.5293 11.4591 11.5293 11.3291V11.0091H13.2793C14.9893 11.0091 16.3993 9.73914 16.6393 8.09914C16.6793 7.84914 16.4793 7.61914 16.2293 7.61914H5.23933C4.98933 7.61914 4.78933 7.83914 4.82933 8.09914C5.05933 9.74914 6.47933 11.0091 8.18933 11.0091H8.17933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4591 9.55924C15.7591 10.6792 14.5691 11.4192 13.2291 11.4192H11.8491V11.7392C11.8491 11.8692 11.7391 11.9792 11.6091 11.9792H9.81906C9.68906 11.9792 9.58906 11.8692 9.58906 11.7392V11.4192H8.20906C6.86906 11.4192 5.67906 10.6792 4.97906 9.55924C4.91906 9.46924 4.78906 9.49924 4.78906 9.60924L5.02906 15.6092C5.03906 15.8992 5.27906 16.1292 5.56906 16.1292H15.8691C16.1491 16.1292 16.3891 15.8992 16.4091 15.6092L16.6491 9.60924C16.6491 9.49924 16.5191 9.45924 16.4591 9.55924ZM11.4991 13.3692C11.4991 13.5192 11.3791 13.6492 11.2191 13.6492H10.2191C10.0691 13.6492 9.94906 13.5292 9.93906 13.3692V12.5492H11.4891V13.3692H11.4991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60898 7.25957H9.79898V6.84957H9.60898V6.01957H11.829V6.84957H11.639V7.25957H12.729V6.84957H12.539V5.85957C12.539 5.55957 12.299 5.30957 11.989 5.30957H9.44898C9.14898 5.30957 8.89898 5.54957 8.89898 5.85957V6.84957H8.70898V7.25957H9.60898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_280",
    x1: -19.95,
    y1: -8.39,
    x2: 39.03,
    y2: 28.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.45,
    height: 21.45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalT);
export default __webpack_public_path__ + "static/media/totalT.abf90aed5bcab0466246a27d7d1199bc.svg";
export { ForwardRef as ReactComponent };